<template>
    <div id="retrieve_component" class="_main_container _retrieve_bg">
        <div class="_retrieve_header">
            <div class="_retrieve_header_container">
                <img src="~images/logo_normal.svg" />
                <b>找回密码</b>
                <a href="login.html">登录</a>
            </div>
        </div>
        <div style="height:40px;">&nbsp;</div>
        <div class="_operate_step">
            <table cellpadding="0" cellspacing="0" border="0" width="100%">
                <colgroup>
                    <col width="33%" />
                    <col width="34%" />
                    <col width="33%" />
                </colgroup>
                <tr>
                    <td :class="{_ok:step1}"><span class="_step_dot">1</span></td>
                    <td :class="{_ok:step2}"><span class="_step_dot">2</span></td>
                    <td :class="{_ok:step3}"><span class="_step_dot">3</span></td>
                </tr>
                <tr>
                    <th>验证手机号</th>
                    <th>设置新密码</th>
                    <th>设置成功</th>
                </tr>
            </table>
        </div>
        <div style="height:40px;">&nbsp;</div>
        <div class="_retrieve_frame" v-if="step===1">
            <div class="_retrieve_form_container">
                <p class="_common_form_row">
                    <label>手机号</label>
                    <input :class="{_er:v_mobile}" type="text" placeholder="输入手机号码" maxlength="11" v-model.trim="parameters.mobile" @keyup.enter="enterSubmit()" @focus="focusInput('mobile')" @blur="blurInput('mobile')" />
                    <span v-if="v_mobile" class="_common_form_row_tips">输入正确格式的手机号码</span>
                </p>
<!--                <p class="_common_form_row" style="height: 34px;">-->
<!--                    <label style="height: 34px; line-height: 34px;">滑动验证</label>-->
<!--                    <b class="_v_slide_con"><span id="slide" class="nc-container"></span></b>-->
<!--                    <span v-if="v_slide" class="_common_form_row_tips">鼠标拖动滑块进行验证</span>-->
<!--                </p>-->
                <p class="_common_form_row">
                    <label>手机验证码</label>
                    <input id="verifyCode" :class="{_er:v_verifyCode}" type="text" placeholder="输入手机验证码" maxlength="6" v-model.trim="parameters.verifyCode" @keyup.enter="enterSubmit()" @focus="focusInput('verifyCode')" @blur="blurInput('verifyCode')" />
                    <button v-show="mobile_countDown_show" @click="getVerifyCode('mobile')">获取验证码</button>
                    <button v-show="!mobile_countDown_show" class="_disabled">{{mobile_countDown}}秒后重新获取</button>
                    <span v-if="v_verifyCode" class="_common_form_row_tips">输入手机验证码</span>
                </p>
                <div class="_common_button">
                    <a href="javascript:;" @click="submit()">下一步</a>
                </div>
            </div>
        </div>
        <div class="_retrieve_frame" v-if="step===2">
            <div class="_retrieve_form_container">
                <p class="_common_form_row">
                    <label>新密码</label>
                    <input :class="{_er:v_password1}" type="password" placeholder="密码只能由8至18位的数字和字母组成" maxlength="18" v-model.trim="parameters.password1" @keyup.enter="enterSubmit()" @focus="focusInput('password1')" @blur="blurInput('password1')" />
                    <span v-if="v_password1" class="_common_form_row_tips">密码只能由8至18位的数字和字母组成</span>
                </p>
                <p class="_common_form_row">
                    <label>确认新密码</label>
                    <input :class="{_er:v_password2}" type="password" placeholder="密码只能由8至18位的数字和字母组成" maxlength="18" v-model.trim="parameters.password2" @keyup.enter="enterSubmit()" @focus="focusInput('password2')" @blur="blurInput('password2')" />
                    <span v-if="v_password2 && !v_pwd1_pwd2" class="_common_form_row_tips">密码只能由8至18位的数字和字母组成</span>
                    <span v-if="v_pwd1_pwd2" class="_common_form_row_tips">两次输入密码不一致</span>
                </p>
                <div class="_common_button">
                    <a href="javascript:;" @click="submit()">提交</a>
                </div>
            </div>
        </div>
        <div class="_retrieve_frame" v-if="step===3">
            <div class="_retrieve_form_container">
                <span class="_operate_result_icon"><i class="fa fa-check-circle"></i></span>
                <b class="_operate_result_message">新密码设置成功</b>
                <a class="_operate_result_jumper" :href="link_to"><i>{{link_countDown}}</i>直接跳转&raquo;</a>
            </div>
        </div>
        <PageFloatButtons></PageFloatButtons>
        <LoginVerify
            :is-show="loginVerifyShow"
            :validate="validate"
            :get-data="getDragVerification"
            @control="loginVerifyControl"
        ></LoginVerify>
    </div>
</template>

<script>
    import LoginVerify from '../../component/loginVerify'
    import PageFloatButtons from "component/public/PageFloatButtons.vue"

    import {getDragVerification, checkoutAndSendVerifyCodeForFindPwd} from "api/index";
    let dataObj={
        loginVerifyShow:false,//控制图形验证弹窗
        taskId:'',//图形验证任务id
        requestUrl:websiteConfig.commonRequestUrl,
        tkName:websiteConfig.tokenStringName,
        token:getLocalStorage(websiteConfig.tokenStringName),
        accountBaseInfo:{},
        step:1,
        step1:true,
        step2:false,
        step3:false,
        mobile_countDown:60,
        mobile_countDown_show:true,
        link_countDown:5,
        link_to:"login.html",
        parameters:{
            mobile:"",
            verifyCode:"",
            password1:"",
            password2:""
        },
        // slide:false,
        // v_slide:false,
        v_mobile:false,
        v_password1:false,
        v_password2:false,
        v_pwd1_pwd2:false,
        v_verifyCode:false
    };
    export default {
        data(){
            return dataObj
        },
        components:{
            LoginVerify,
            PageFloatButtons
        },
        methods: {
            focusInput(ele){
                let _this=this;
                _this["v_"+ele]=false;
            },
            blurInput(ele){
                let _this=this;
                let value=_this.parameters[ele];
                let validate=true;
                if(ele==="mobile"){
                    validate=value.common_check_mobile();
                }
                else if(ele==="password1"){
                    _this["v_password2"]=false;
                    _this["v_pwd1_pwd2"]=false;
                    validate=value.common_check_password();
                    let v1=_this.parameters['password2'];
                    if(validate && v1!=="" && v1!==value){
                        _this.v_pwd1_pwd2=true;
                    }
                }
                else if(ele==="password2"){
                    _this["v_pwd1_pwd2"]=false;
                    let v2=_this.parameters['password1'];
                    validate=value.common_check_password();
                    if(validate && v2!==value){
                        validate=false;
                        _this.v_pwd1_pwd2=true;
                    }
                }
                else{
                    validate=value.required();
                }
                if(!validate){
                    _this["v_"+ele]=true;
                }
                return validate;
            },
            getVerifyCode(ele){
                let _this=this;

                if(!_this.blurInput(ele)){
                    return false;
                }

                this.loginVerifyControl(true)
            },
            submit(){
                let _this=this;
                let reqData=_this.parameters;
                let requestUrl="";
                if(_this.step===1){
                    if(!_this.blurInput("mobile")){
                        return false;
                    }
                    // if(!_this.slide){
                    //     _this.v_slide=true;
                    //     return false;
                    // }
                    if(!_this.blurInput("verifyCode")){
                        return false;
                    }
                    requestUrl=_this.requestUrl+"/user/findpwd/verify/valid/";
                }
                if(_this.step===2){
                    if(!_this.blurInput("password1")){
                        return false;
                    }
                    if(!_this.blurInput("password2")){
                        return false;
                    }
                    requestUrl = _this.requestUrl+"/user/findpwd/reset/";
                }
                $.ajax({
                    type: "POST",
                    url: requestUrl,
                    data: JSON.stringify(reqData),
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    beforeSend: function (request) {
                        $.addWaiting("稍等");
                        request.setRequestHeader("token", _this.token);
                    },
                    success: function (data) {
                        let code = data.code;
                        let msg = data.msg;
                        if (code === 0) {
                            if(_this.step===1){
                                _this.step=2;
                                _this.step2=true;
                                $.removeWaiting();
                                return false;
                            }
                            if(_this.step===2){
                                _this.step=3;
                                _this.step3=true;
                                let intervalObj=setInterval(function(){
                                    _this.link_countDown -= 1;
                                    if(_this.link_countDown<=0){
                                        _this.link_countDown = 5;
                                        clearInterval(intervalObj);
                                        window.location.href=_this.link_to;
                                    }
                                },1000);
                            }
                        }
                        else{
                            $.userAlert(msg);
                        }
                        $.removeWaiting();
                    },
                    error: function (error) {
                        $.ajaxError(error);
                    }
                });
            },
            enterSubmit(){
                let _this=this;
                _this.submit();
            },
            countDownFun(ele){
                let _this=this;
                _this[ele+"_countDown_show"]=false;
                let intervalObj=setInterval(function(){
                    _this[ele+"_countDown"]-= 1;
                    if(_this[ele+"_countDown"]<=0){
                        _this[ele+"_countDown"]=60;
                        _this[ele+"_countDown_show"]=true;
                        clearInterval(intervalObj);
                    }
                },1000);
            },
            initSlideVerOperate(domId){
                let _this=this;
                var nc_token = ["CF_APP_1", (new Date()).getTime(), Math.random()].join(':');
                var NC_Opt = {
                    renderTo: "#"+domId,
                    appkey: "CF_APP_1",
                    scene: "register",
                    token: nc_token,
                    customWidth: "100%",
                    trans:{"key1":"code0"},
                    elementID: ["usernameID"],
                    is_Opt: 0,
                    language: "cn",
                    isEnabled: true,
                    timeout: 3000,
                    times:5,
                    apimap: {},
                    callback: function (data) {
                        _this[domId]=true;
                        _this['v_'+domId]=false;
                    }
                };
                var nc = new noCaptcha(NC_Opt);
                nc.upLang('cn', {
                    _startTEXT: "按住滑块，拖动到最右边",
                    _yesTEXT: "验证通过",
                    _error300: "哎呀，出错了，点击<a href=\"javascript:__nc.reset()\">刷新</a>再来一次",
                    _errorNetwork: "网络不给力，<a href=\"javascript:__nc.reset()\">点击刷新</a>"
                });
            },
            /**获取图形验证资源*/
            getDragVerification(){
                return new Promise((resolve,reject) => {
                    getDragVerification().then(res=>{
                        res = res.data;
                        if(res.code === 0){

                            let {
                                baseImageUrl,
                                sliderImageUrl,
                                height,
                                taskId,
                            } = res.content;
                            this.taskId = taskId;

                            resolve({
                                basePic:baseImageUrl,
                                sliderPic:sliderImageUrl,
                                picPartPositionY:height
                            })

                        }else{
                            $.userAlert(res.msg);
                            reject()
                        }
                    }).catch(()=>{
                        $.userAlert('网络错误，请刷新重试');
                        reject()
                    })
                })
            },
            /**图形验证方法*/
            validate(picCode){
                return new Promise((resolve,reject) => {
                    checkoutAndSendVerifyCodeForFindPwd({
                        mobile:this.parameters.mobile,
                        picUUID:this.taskId,
                        picCode
                    }).then(res=>{
                        res = res.data;
                        if(res.code === 0){
                            this.loginVerifyControl(false)
                            this.countDownFun('mobile');
                            resolve()
                            $.userAlert('验证码已发送');
                        }else{
                            $.userAlert(res.msg);
                            reject()
                        }
                    }).catch(()=>{
                        $.userAlert('网络错误，请刷新重试');
                        reject()
                    })
                })
            },
            /**登录验证控制*/
            loginVerifyControl(data){
                this.loginVerifyShow = data;
            },
        },
        created(){},
        mounted(){
            $.pageWaiting();
            let _this=this;
            if(typeof _this.token === "string" && _this.token !== ""){
                window.location.href="user_index.html";
            }
            window.onload=function(){
                let rndNum=getCommonId();
                let gSrc="//g.alicdn.com/sd/ncpc/nc.js?t="+rndNum;
                loadScript(gSrc,function(){
                    setTimeout(function(){
                        $("#retrieve_component").animate({"opacity":1},500);
                        $.removePageWaiting();
                    },500);
                    loadScript("https://qiyukf.com/script/debae06a181a195ea71396d3f3933069.js?hidden=1",function(){});
                });
            };
        }
    }
</script>

<style>
    ._retrieve_bg{
        background-image: url("~images/register_bg.jpg");
        opacity: 0;
    }
    ._retrieve_header{
        width: 100%;
        border-bottom:solid 1px #dedede;
        background-color: #fff;
    }
    ._retrieve_header_container{
        clear: both;
        width:1200px;
        height:68px;
        margin: 0 auto;
        position: relative;
    }
    ._retrieve_header_container>img{
        display:inline-block;
        height: 58px;
        margin-top: 5px;
    }
    ._retrieve_header_container>b{
        display:inline-block;
        font-size: 1.4rem;
        margin-left: 10px;
        padding-left: 10px;
        color:#333;
        font-weight: normal;
        border-left: solid 1px #333;
        position: relative;
        top: -22px;
    }
    ._retrieve_header_container>a{
        display:inline-block;
        font-size:1.4rem;
        color:#333;
        text-decoration: underline;
        position: absolute;
        top: 26px;
        right:0px;
    }
    ._retrieve_frame{
        width: 30%;
        margin: 0 auto;
        background-color: #fff;
        box-shadow: 0px 0px 10px 0px #ddd;
        position: relative;
    }
    ._retrieve_form_container{
        width:80%;
        margin: 0 auto;
        padding:20px 0px;
    }
    ._operate_step{
        width:30%;
        margin: 0 auto;
    }
    ._operate_step>table{
        width: 100%;
    }
    ._operate_step>table td{
        height: 24px;
        text-align: center;
        background-image: url("~images/_step_line_n.png");
        background-position: left center;
        background-repeat: repeat-x;
    }
    ._operate_step>table td>._step_dot{
        display: inline-block;
        width:24px;
        height:24px;
        line-height: 24px;
        text-align: center;
        border-radius: 16px;
        color:#ffffff;
        border:solid 4px #ebeced;
        background-color: #bbbbbb;
    }
    ._operate_step>table td._ok{
        background-image: url("~images/_step_line_s.png");
    }
    ._operate_step>table td._ok>._step_dot{
        border:solid 4px #d7e4f4;
        background-color: #2f81e8;
    }
    ._operate_step>table th{
        font-size: 1.2rem;
        font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// src/component/sign/Retrieve.vue